import * as React from 'react';
import {classNames} from '@shopify/react-utilities/styles';
import {FilterOption} from 'interfaces';
import {FilterUpdateFunction} from '../../types';

export interface Props {
  option: FilterOption;
  filterType: string;
  namespace?: string;
  onInputChange?: FilterUpdateFunction;
  filterOptionState: boolean;
}

function NOOP() {}

export class FilterSectionOption extends React.Component<Props> {
  handleInputChange = (event) => {
    const {filterType, option, onInputChange = NOOP} = this.props;
    onInputChange(filterType, option.optionId, event.target.checked);
  };

  render() {
    const {filterOptionState, filterType, option, namespace = 'react'} = this.props;

    const inputId = `${namespace}-${filterType}${option.optionId}`;

    const inputProps = {
      className: classNames('marketing-checkbox', 'shop-filters__checkbox'),
      checked: filterOptionState,
      'data-filter-type': filterType,
      disabled: option.disabled,
      id: inputId,
      name: option.label,
      onChange: this.handleInputChange,
      type: 'checkbox',
      value: option.optionId,
    };

    return (
      <li className={classNames('shop-filters__element')}>
        <input {...inputProps} />
        <label
          className={classNames('marketing-checkbox-label', 'shop-filters__label')}
          htmlFor={inputId}
        >
          {option.label}
        </label>
        <span className={classNames('shop-filters__count')}>{option.count}</span>
      </li>
    );
  }
}
